import _taggedTemplateLiteral from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import { svg } from 'lit';
export const cursorSvg = svg(_templateObject || (_templateObject = _taggedTemplateLiteral([" <svg fill=\"none\" viewBox=\"0 0 13 4\">\n  <path fill=\"currentColor\" d=\"M.5 0h12L8.9 3.13a3.76 3.76 0 0 1-4.8 0L.5 0Z\" />\n</svg>"])));
//# sourceMappingURL=cursor.js.map